import { y } from '@circlefin/form'
import { LocalsForms } from '@features/locales/forms'
import { TypeGuards } from '@services/type-guards'

import type { CountryCode } from '@shared/graphql'

/**
 * State schema
 * required when Usa or Canada.
 */
export const stateSchema = (name = 'country') =>
  y.string().when(name, (countryField: CountryCode[], schema) => {
    if (TypeGuards.Common.isUsaOrCanada(countryField[0])) {
      return LocalsForms.Dropdown.stateSchema.required()
    }

    return schema
  })
